module.exports = __webpack_public_path__ + "img/420-shop-zh.a0ea5d72.svg";